import React from 'react'

const SalaryIcon: React.FC = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
		<path
			className="stroke-current"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			d="M12.121 13.536c-1.171 1.952-3.07 1.952-4.242 0-1.172-1.953-1.172-5.119 0-7.072 1.171-1.952 3.07-1.952 4.242 0M6 8.5h4m-4 3h4m9-1.5a9 9 0 11-18 0 9 9 0 0118 0z"
		></path>
	</svg>
)

export default SalaryIcon
